import { makeStyles } from "@material-ui/core";

export const soldThisMonthStyle = makeStyles((theme) => ({
    graphWrapper: {
        height: '100%',
        minHeight: '20rem',
        display: 'flex',
        flexDirection: 'column',
    },
    body: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem 1.5rem 1.5rem',
        gap: '0.5rem',
    },
    count: {
        fontSize: '6rem',
        fontWeight: 800,
        color: '#1a2b3c',
        lineHeight: 1,
    },
    countLabel: {
        fontSize: 16,
        color: theme.palette.text.secondary,
        marginBottom: '0.75rem',
    },
    divider: {
        width: '100%',
        borderTop: '1px solid #e0e0e0',
        margin: '0.5rem 0',
    },
    netLine: {
        fontSize: 22,
        fontWeight: 700,
        color: theme.palette.success.main,
    },
}));
